// Centralised number/currency formatting.
// Format: 1,234,567.89 — comma thousands separator, full-stop decimal.

// Money: always 2 decimals (e.g. 1234.5 -> "1,234.50"). Prefix "R" at call site.
export const money = (n) =>
  Number(n || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// Whole-number counts with thousands separators (e.g. 1234 -> "1,234").
export const num = (n) =>
  Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 0 });

// Numeric round to 2 decimals (returns a Number, for calculations — NOT display).
export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
